// @flow
import styled from 'styled-components';

export const SearchResultsCountWrap = styled.div`
  text-align: center;
  padding-bottom: 2.4rem;
`;
